/** Shared payment dependency failures every route that talks to Stripe or payments tables may return. */
export const paymentsDependencyErrors = {
  BAD_GATEWAY: {
    message: "Payments are temporarily unavailable. Try again in a moment.",
  },
  UNPROCESSABLE_CONTENT: {
    message: "This offer is no longer available.",
  },
} as const;
